import React from 'react';
import { createRoot } from 'react-dom/client';
import App from "./App";
import { AppLoader } from "./components/AppLoader";
import "./styles.css";

declare global {
  interface Window {
    drupalSettings: {
      catalogPage: {
        groupId: string;
        groupName: string;
      };
    };
    Drupal: {
      behaviors: Record<
        string,
        {
          attach: (context: Document | HTMLElement, settings: any) => void;
        }
      >;
    };
  }
}

// Cookie consent compatible initialization
function initializeCatalogPageReact() {
  const container = document.getElementById("catalog-page-root");
  if (!container) {
    return;
  }

  // Show loader immediately
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <AppLoader />
    </React.StrictMode>
  );

  // Get initial data from the page
  const initialDataElement = document.querySelector("[data-initial-data]");
  let initialData: any = {};

  if (initialDataElement) {
    try {
      initialData = JSON.parse(
        initialDataElement.getAttribute("data-initial-data") || "{}"
      );
    } catch (e) {
      console.warn("Failed to parse initial data:", e);
    }
  }

  // Get current cart ID from session storage or cookie
  const getCartId = async (): Promise<string> => {
    // Try to get from cookie first
    const cartIdFromCookie =
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("cart_current="))
        ?.split("=")[1] || "";

    if (cartIdFromCookie) {
      return cartIdFromCookie;
    }

    // If not found in cookie, try to fetch from server
    try {
      const response = await fetch("/cart/current", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data.id || "";
      }
    } catch (error) {
      console.error("Error fetching cart ID:", error);
    }

    return "";
  };

  // Initialize the React app
  const initApp = async () => {
    try {
      const cartId = await getCartId();

      // Replace loader with actual app
      root.render(
        <React.StrictMode>
          <App
            groupId={initialData.groupId || ""}
            groupName={initialData.groupName || ""}
            cartId={cartId}
          />
        </React.StrictMode>
      );
    } catch (error) {
      console.error("Error initializing app:", error);
      // Show error state if initialization fails
      root.render(
        <React.StrictMode>
          <div className="flex items-center justify-center min-h-[400px] bg-white">
            <div className="text-center">
              <div className="text-red-500 text-6xl mb-4">⚠️</div>
              <p className="text-lg text-gray-700 font-semibold">
                Greška pri učitavanju
              </p>
              <p className="mt-2 text-sm text-gray-500">
                Molimo osvježite stranicu
              </p>
            </div>
          </div>
        </React.StrictMode>
      );
    }
  };

  // Small delay to ensure smooth transition
  setTimeout(initApp, 100);
}

 document.addEventListener("DOMContentLoaded", function () {
   initializeCatalogPageReact();
 });
// Check if Drupal is available
// if (typeof window.Drupal !== "undefined" && window.Drupal.behaviors) {
//   // Use Drupal behaviors when available
//   window.Drupal.behaviors.catalogPageReact = {
//     attach: async (context: any, settings: any) => {
//       if (context === document) {
//         const container = document.getElementById("catalog-page-root");
//         if (!container) {
//           return;
//         }

//         // Get current cart ID from session storage
//         const cartId =
//           document.cookie
//             .split("; ")
//             .find((row) => row.startsWith("cart_current="))
//             ?.split("=")[1] || "";

//         if (!cartId) {
//           // Make AJAX call to get cart ID if not found in cookie
//           try {
//             const response = await fetch("/cart/current", {
//               method: "GET",
//               headers: {
//                 "Content-Type": "application/json",
//               },
//             });

//             if (response.ok) {
//               const data = await response.json();
//               if (data.id) {
//                 // Set the cart ID in settings
//                 settings.catalogPage = settings.catalogPage || {};
//                 settings.catalogPage.cartId = data.id;
//               }
//             }
//           } catch (error) {
//             console.error("Error fetching cart ID:", error);
//           }
//         }

//         settings.catalogPage = settings.catalogPage || {};
//         console.log(settings.catalogPage);

//         const root = createRoot(container);
//         root.render(
//           <React.StrictMode>
//             <App
//               groupId={settings.catalogPage?.groupId || ""}
//               groupName={settings.catalogPage?.groupName || ""}
//               cartId={settings.catalogPage?.cartId || cartId}
//             />
//           </React.StrictMode>
//         );
//       }
//     },
//   };
// } else {
//   // Fallback for when Drupal is not available (cookie consent issues)
//   document.addEventListener("DOMContentLoaded", function () {
//     // Wait a bit more for Drupal to potentially load
//     setTimeout(function () {
//       if (typeof window.Drupal !== "undefined" && window.Drupal.behaviors) {
//         // Drupal is now available, attach the behavior
//         window.Drupal.behaviors.catalogPageReact = {
//           attach: async (context: any, settings: any) => {
//             if (context === document) {
//               const container = document.getElementById("catalog-page-root");
//               if (!container) {
//                 return;
//               }

//               const cartId =
//                 document.cookie
//                   .split("; ")
//                   .find((row) => row.startsWith("cart_current="))
//                   ?.split("=")[1] || "";

//               if (!cartId) {
//                 try {
//                   const response = await fetch("/cart/current", {
//                     method: "GET",
//                     headers: {
//                       "Content-Type": "application/json",
//                     },
//                   });

//                   if (response.ok) {
//                     const data = await response.json();
//                     if (data.id) {
//                       settings.catalogPage = settings.catalogPage || {};
//                       settings.catalogPage.cartId = data.id;
//                     }
//                   }
//                 } catch (error) {
//                   console.error("Error fetching cart ID:", error);
//                 }
//               }

//               settings.catalogPage = settings.catalogPage || {};

//               const root = createRoot(container);
//               root.render(
//                 <React.StrictMode>
//                   <App
//                     groupId={settings.catalogPage?.groupId || ""}
//                     groupName={settings.catalogPage?.groupName || ""}
//                     cartId={settings.catalogPage?.cartId || cartId}
//                   />
//                 </React.StrictMode>
//               );
//             }
//           },
//         };
//         // Manually trigger the behavior
//         window.Drupal.behaviors.catalogPageReact.attach(document, {});
//       } else {
//         // Drupal still not available, use fallback initialization

//       }
//     }, 1000);
//   });
// }
